import { H3 } from "components/Text";
import BaseModal from "./BaseModal";
import PasswordResetForm from "components/PasswordResetForm";
import { useTranslation } from "next-i18next/pages";

interface Props {
    closeModal: () => void;
    modalOpen: boolean;
  }

const PasswordResetModal: React.FC<Props> = ({
    closeModal,
    modalOpen,
  }) => {
    const { t } = useTranslation();

    return (
        <BaseModal closeModal={closeModal} modalOpen={modalOpen}>
            <div className="flex flex-col items-center justify-center">
            <H3 className="!text-lg leading-6 mb-2 font-medium text-gray-900">
                <b>{t('Password reset')}</b>
            </H3>
                <PasswordResetForm closeModal={closeModal}/>
            </div>
        </BaseModal>
    );
  }

  export default PasswordResetModal;